var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',_vm._g({attrs:{"color":"secondary","loading":_vm.isLoading,"disabled":_vm.isDisabled}},_vm.$listeners),[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-close")]),_vm._v(" Cancelar ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }